import React, { useCallback, useMemo } from 'react';
import { OffersSlice } from '../../../../types';
import { LayoutMode } from '../../../../components/layout-buttons/types';
import Offer from './offer';
import ProductOfferContainer from '../productOffersContainer';
import { OffersGrid } from '../offers-grid';
import { Ads } from '../ads';

type Props = Pick<
  OffersSlice,
  | 'id'
  | 'pageInfo'
  | 'offers'
  | 'productsCount'
  | 'storeCount'
  | 'legalText'
  | 'availableSorts'
  | 'currentSort'
  | 'maxHitsAmount'
>;

const availableSortsTranslations: Record<string, string> = {};

const Offers = ({ offers, ...rest }: Props) => {
  const onLayoutChange = useCallback(() => {}, []);

  const supportedViewModes = useMemo(() => [LayoutMode.GRID], []);
  return (
    <ProductOfferContainer
      {...rest}
      layout={LayoutMode.GRID}
      onLayoutChange={onLayoutChange}
      availableSortsTranslations={availableSortsTranslations}
      supportedViewModes={supportedViewModes}
    >
      <OffersGrid
        isOffers
        offers={offers.map(offer => (
          <Offer key={offer.id} offer={offer} />
        ))}
      >
        <Ads offersLength={offers.length} layout={LayoutMode.GRID} />
      </OffersGrid>
    </ProductOfferContainer>
  );
};

export default Offers;
